import { API_URL } from '../config';

/**
 * Converts an S3 key or legacy URL to a working avatar URL
 * This prevents infinite loops by using a REST endpoint instead of GraphQL resolvers
 * 
 * @param {string | null | undefined} avatarUrl - The avatar URL or S3 key from the database
 * @returns {string} A working avatar URL or placeholder
 */
export function getAvatarUrl(avatarUrl) {
  // Handle null/undefined/empty
  if (!avatarUrl) {
    return 'https://placehold.co/80x80?text=No+Avatar';
  }

  // Handle base64 data URLs (image previews during upload) - return as-is
  if (avatarUrl.startsWith('data:image/')) {
    return avatarUrl;
  }

  // Handle blob URLs (another type of preview) - return as-is
  if (avatarUrl.startsWith('blob:')) {
    return avatarUrl;
  }

  // If it's already a full HTTP/HTTPS URL, return it as-is
  // This includes S3 pre-signed URLs (same as products)
  if (avatarUrl.startsWith('http://') || avatarUrl.startsWith('https://')) {
    return avatarUrl;
  }

  // Legacy S3 keys (shouldn't happen with new uploads) - convert to backend endpoint
  if (avatarUrl.startsWith('avatars/')) {
    return `${API_URL}/api/users/avatar/${avatarUrl}`;
  }

  // Unknown format - return placeholder
  return 'https://placehold.co/80x80?text=Unknown';
}

/**
 * Checks if an avatar URL is a valid image source
 * @param {string | null | undefined} avatarUrl 
 * @returns {boolean}
 */
export function isValidAvatarUrl(avatarUrl) {
  if (!avatarUrl) return false;
  
  // Check if it's a placeholder
  if (avatarUrl.includes('placehold.co')) return true;
  
  // Check if it's our API endpoint
  if (avatarUrl.includes('/api/users/avatar/')) return true;
  
  // Check if it's an S3 URL
  if (avatarUrl.includes('.s3.') && avatarUrl.includes('amazonaws.com')) return true;
  
  // Check if it's an S3 key format
  if (avatarUrl.startsWith('avatars/')) return true;
  
  return false;
}

